import { render, staticRenderFns } from "./PurchaseTokenModal.vue?vue&type=template&id=509cf9b6&scoped=true"
import script from "./PurchaseTokenModal.vue?vue&type=script&lang=js"
export * from "./PurchaseTokenModal.vue?vue&type=script&lang=js"
import style0 from "./PurchaseTokenModal.vue?vue&type=style&index=0&id=509cf9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509cf9b6",
  null
  
)

export default component.exports